import { React, useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { motion } from 'framer-motion';
import Table from 'react-bootstrap/Table';

import "./index.scss";

import Button from "../../../../components/ui/Button";
import ProfileAvatar from "../../../../components/ui/ProfileAvatar";
import SkeletonLoader from "../../../ui/SkeletonLoader";

import UpdateUserStatusModal from "../UpdateUserStatusModal";

import { formatDate, getUserImageUrl, formatNumber, getloggedInUserType } from "../../../../utils/util";

import { useSelector, useDispatch } from 'react-redux';
import { resetUserDetailsResponse } from "../../../../store/actions/usersAction";


const UserListView = ({usersList, loading}) => {

    const updateUserStatusSingleResponse = useSelector((state) => state.users?.updateUserStatusSingleResponse);

    const dispatch = useDispatch();

    const { t } = useTranslation();

    const navigate = useNavigate();

    const [showUpdateUserStatusModal, setShowUpdateUserStatusModal] = useState(false);
    const [selectedUserData, setSelectedUserData] = useState(null);

    const updatedUserStatus = (data) => {
        setShowUpdateUserStatusModal(true);
        setSelectedUserData(data)
    }

    const getSecondaryText = (data) => {
        if(getloggedInUserType() === "internal") {
            return `${data?.role} | ${data.user_type} ${data?.customer_detail?.name !== null ? `- ${data?.customer_detail?.name}` : ""}`;
        } else {
            return `${data?.role}`
        }
    }

    useEffect(()=>{
        if(updateUserStatusSingleResponse != null) {
            setShowUpdateUserStatusModal(false)
        }
    },[updateUserStatusSingleResponse])

    return (
        <Row>
            <Col md="12">
                {
                    loading ?
                    <div className="list-view-container users-list-view-table users-tab-table p-3 mt-4">
                        <SkeletonLoader type={"line"} count={5} currentPage={"userlist"} />
                    </div>
                    :
                    <>
                        <div className="list-view-container users-list-view-table users-tab-table p-3 mt-4">
                            <Table responsive="lg">
                                <thead>
                                    <tr>
                                        <th>{t("users.userListView.users")}</th>
                                        <th>{t("users.userListView.status")}</th>
                                        <th>{t("users.userListView.totalScan")}</th>
                                        <th>{t("users.userListView.totalActiveScan")}</th>
                                        <th>{t("users.userListView.totalPassiveScan")}</th>
                                        <th>{t("users.userListView.joinedOn")}</th>
                                        <th>{t("users.userListView.lastLogin")}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        usersList?.results.length > 0 &&
                                        usersList.results.map((data, index)=>{
                                            return (
                                                <motion.tr
                                                    key={index}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    // whileInView={{ opacity: 1, y: 0 }}
                                                    // viewport={{ once: true }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                                >
                                                    <td className="user-profile">
                                                        <ProfileAvatar type="profile" 
                                                            secondaryText={data?.role !== null ? getSecondaryText(data) : "Role Not Assigned"}
                                                            firstName={data.firstname} 
                                                            lastName={data.lastname} 
                                                            imageUrl={getUserImageUrl(data)} 
                                                            emailVerifiedStatus={data?.email_status}
                                                            />
                                                    </td>
                                                    <td>
                                                        <label className={`user-status text-capitalize ${data.status === "active" ? "active" : "disabled"}`}>{data.status}</label>
                                                    </td>
                                                    <td>
                                                        <p>{formatNumber(data?.stats?.scans?.total)}</p>
                                                    </td>
                                                    <td>
                                                        <p>{formatNumber(data?.stats?.scans?.active)}</p>
                                                    </td>
                                                    <td>
                                                        <p>{formatNumber(data?.stats?.scans?.passive)}</p>
                                                    </td>
                                                    <td>
                                                        <p>{formatDate(data?.created_at)}</p>                                                
                                                    </td>
                                                    <td>
                                                        <p>{formatDate(data.last_login)}</p>
                                                    </td>
                                                    <td>
                                                        <div className='organization-list-view d-flex gap-3 users-list-view-btn'>
                                                            {data.status !== "active" &&<button className="view-details-btn active-user w-100" onClick={()=>{updatedUserStatus(data)}}>{t("users.activateuser")}</button>}
                                                            {data.status === "active" && <button className="view-details-btn disable-user w-100" onClick={()=>{updatedUserStatus(data)}}>{t("users.disableUser")}</button>}
                                                            <Button buttonText={"View"} buttonType="primary" buttonClicked={()=>{
                                                                dispatch(resetUserDetailsResponse())
                                                                navigate(`/users/details/${data.user_id}`)
                                                                }}/>
                                                        </div>
                                                    </td>
                                                </motion.tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                            <UpdateUserStatusModal show={showUpdateUserStatusModal} selectedUserData={selectedUserData} onHide={() => setShowUpdateUserStatusModal(false)}/>
                        </div>
                    </>
                }                
            </Col>
        </Row>
    )
}

export default UserListView;